import React, { useState, useRef, useEffect, useMemo } from 'react'
import { FormattedMessage } from 'react-intl';
import Table from '../../components/Table/Table'
import API from '../../utils/API'
import constants from '../../utils/constants';
import tableCheckbox from '../../components/Inputs/tableCheckbox'
import useInfiniteScroll from '../../components/common/useInfiniteScroll';

function SelectTable(props) {
	const { 
    success, setSuccess,
    error, setError,
    setCompanies,
    displayReceivers
  } = props;

  const tableRef = useRef();
  const tableWrapperRef = useRef();
  const [dataLoaded, setDataLoaded] = useState(false);
  const [data, setData] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [selectedIds, setSelectedIds] = useState({});
  const [sortByCol, setSortByCol] = useState('companyName');
  const [sortByAsc, setSortByAsc] = useState(true);
  const [startIndexForTable, setStartIndexForTable] = useState(0);

  // Search state
	const [searchValue, setSearchValue] = useState('');

  const companyDataMap = React.useMemo(() => {
    const map = { data: {}, ids: [], selectedIds: {}, filteredIds: [] };
    loadTable(map);
    return map;
  }, [searchValue, sortByCol, sortByAsc]);

  const { generateDataSlice, sortMap, setSortBy } = useInfiniteScroll({
    dataMap: companyDataMap,
    setData,
    setStartIndexForTable,
    startIndexForTable,
    pageSize: 100, 
    sortByCol,
    setSortByCol,
    sortByAsc, 
    setSortByAsc,
    tableWrapperRef,
    searchValue,
    tableRef,
  });
    
  /**
   * Load table with data from GET /api/accounts
   * @param {*} map 
   * @param {*} resetSelection 
   */
  function loadTable(map, resetSelection=true) {
    //Reset map
    map.data = {};
    map.ids = [];
    map.sortedIds = [];
    map.filteredIds = [];
    if(resetSelection){
      map.selectedIds = {}
    }

    API.getAccounts()
      .then((res)=>{
        // Extract company names from res.data
        // const companyNames = res.data.map((account) => account.company_name);
        setCompanies(res.data);
        
        res.data.forEach((account)=>{
          map.data[account.id] = {
            id: account.id,
            companyName: account.company_name,
            email: account.email,
            checked: false,
          }
        })
        map.filteredIds = Object.keys(map.data);
        map.ids = Object.keys(map.data);
        if(searchValue !== "") {
          tableRef.current.search(map)
        } else {
          sortMap(map);
          setData(generateDataSlice(map));
          setDataCount(map.sortedIds.length);
        }   
        setTotalDataCount(map.ids.length);
        setSelectedIds(map.selectedIds);
        setDataLoaded(true);
      })
      .catch((err) => {
        console.error('Error loading companies:', err);
        setDataLoaded(true);
      })
  }

  /**
   * Handle the click event for the "Show Receivers" button
   */
  const handleFilterReceiversClick = () => {
    // Get the selected rows (companies)
    const selectedRowsInfo = Object.keys(selectedIds).map((selectedId) =>
      data.find((item) => item.id === selectedId)
    );
    
    // Pass selected company ID to the parent (HardwareWarranty) via props
    if (selectedRowsInfo.length > 0) {
      const selectedCompanyId = selectedRowsInfo[0].id;

      // Call the function to display receivers in HW page
      displayReceivers(selectedCompanyId);
    }
  };

  const tableColumnArray = [
    {
      Header: tableCheckbox,
      id: 'checkbox',
      accessor: 'checked',
      Cell: tableCheckbox,
      isVisible: true,
      width: 63,
      maxWidth: 63,
    },
    {
      Header: 'COMPANY_NAME',  
      id: 'companyName',  
      accessor: 'companyName',  
      isVisible: true,  
    },
    {
      Header: 'ACCOUNT_OWNER',
      id: 'email',
      accessor: 'email',
      isVisible: true,
    },
  ]
  
  const tableColumns = useMemo(
  
  () => tableColumnArray, [])

	const buttons = {
    toolbarLeftButtons : (
      <> 
        <button
          className="btn"
          onClick={handleFilterReceiversClick}
          // disabled={Object.keys(selectedIds).length === 0}
        >
          <FormattedMessage id="SHOW_RECEIVERS" />
        </button>
      </>
    )
  }

  // Props to pass to our table 
  const tableProps = {
    pageType: constants.pageType.Companies,
    modalId: null,
    columns: tableColumns,
    data, setData,
    dataMap: companyDataMap,
    // Data Handling props
    generateDataSlice,
    sortMap,
    buttons,
    dataCount, setDataCount,
    totalDataCount,
    startIndex: startIndexForTable,
    selectedIds, setSelectedIds,
    setSortBy,
    sortByCol,
    sortByAsc,
    success, setSuccess,
    error, setError,
    searchValue, 
    setSearchValue,
    tableRef,
    tableWrapperRef,
    dataLoaded,
    singleSelect: true,
  }

  return (
    <Table {...tableProps} />
  )
}

export default SelectTable;